import { baseApi } from './baseApi';

export interface DotNetAppUpdate {
  filename: string;
  version: string;
  size: number;
  checksum: string | null;
  has_signature: boolean;
  modified_time: string;
  is_deleted?: boolean;
  deleted_at?: string | null;
}

export interface DotNetAppUpdateUpload {
  message: string;
  version: string;
  checksum: string;
  size: number;
  filename: string;
}

export const dotnetAppUpdatesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDotNetAppUpdates: builder.query<DotNetAppUpdate[], void>({
      query: () => '/dotnet-app-updates/list',
      providesTags: ['DotNetAppUpdate'],
    }),

    uploadDotNetAppUpdate: builder.mutation<DotNetAppUpdateUpload, { file: File; version: string; signature_base64: string }>({
      query: ({ file, version, signature_base64 }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/dotnet-app-updates/upload?version=${encodeURIComponent(version)}&signature_base64=${encodeURIComponent(signature_base64)}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['DotNetAppUpdate'],
    }),

    deleteDotNetAppUpdate: builder.mutation<{ message: string }, string>({
      query: (version) => ({
        url: `/dotnet-app-updates/${encodeURIComponent(version)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DotNetAppUpdate'],
    }),
  }),
});

export const {
  useGetDotNetAppUpdatesQuery,
  useUploadDotNetAppUpdateMutation,
  useDeleteDotNetAppUpdateMutation,
} = dotnetAppUpdatesApi;
